import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export default function PlanningMachineAutocomplete({ id, options, value, onChange }) {
    return (
        <Autocomplete
            id={id}
            freeSolo
            openOnFocus
            forcePopupIcon
            size="small"
            options={options}
            value={value || null}
            inputValue={value || ''}
            componentsProps={{ popper: { style: { zIndex: 9999 } } }}
            onInputChange={(_event, nextValue, reason) => {
                if (reason === 'input' || reason === 'clear') onChange(nextValue || '');
            }}
            onChange={(_event, nextValue) => onChange(nextValue || '')}
            renderInput={params => <TextField {...params} size="small" variant="outlined" />}
        />
    );
}
